module.exports = __webpack_public_path__ + "static/media/ICONS-MACHINERIES.0ca48bbf.svg";